import type { KeywordResponse, LanguageCodes, FilterValueRvClassResponse } from '~/types/api'
import type { IKeywordSearch } from '~/types/search/keyword-search'

export const useCommonSearch = () => {
  const { getMarketplaceApiClient } = useApiClients()
  async function getKeywords(key: Ref<string>, locale: LanguageCodes) {
    return useAsyncData(
      key.value,
      async () => {
        const { data: keywordsRaw } = await getMarketplaceApiClient().GET('/Keyword/List', {
          params: {
            query: {
              languageCode: locale
            }
          }
        })
        return keywordsRaw as KeywordResponse[]
      },
      {
        transform: (keywordsRaw) => getKeywordTransformation(keywordsRaw)
      }
    )
  }
  
  function getKeywordTransformation(keywordsRaw: KeywordResponse[]) {
    return keywordsRaw.map((k: KeywordResponse) => {
      let filters: FilterValueRvClassResponse | string | null | undefined = undefined
      
      if (k.filterKey === 'rvBrand') filters = k.filterValues?.brand
      else filters = k.filterValues?.filterRvClass
      
      return {
        slug: k.slug as string,
        displayValue: k.name as string,
        filterKey: k.filterKey as string,
        filterValue: filters
      } as IKeywordSearch
    })
  }
  
  function getKeywordSearchParams(keywords: IKeywordSearch[] | null, slug: string) {
    if (!keywords) return {filterKey: undefined, filterValue: undefined}
    const foundKeyword = keywords.find((k) => k.slug === slug)
    return {filterKey: foundKeyword?.filterKey, filterValue: foundKeyword?.filterValue}
  }
  
  return {
    getKeywords,
    getKeywordSearchParams
  }
}
